<div class="orders-page">
  <!-- ── Breadcrumb ───────────────────────────────────────────── -->
  <nav class="orders-page__breadcrumb custom-nav">
    <ol class="breadcrumb">
      <li
        *ngIf="userRole === 'CLIENT'; else adminCrumb"
        class="breadcrumb-item"
        style="cursor: pointer"
        [routerLink]="'/doqfy/dashboard'"
      >
        Dashboard
      </li>
      <ng-template #adminCrumb>
        <li
          class="breadcrumb-item"
          style="cursor: pointer"
          [routerLink]="'/doqfy/admin-dashboard'"
        >
          Dashboard
        </li>
      </ng-template>
      <li class="breadcrumb-item active" aria-current="page">Order Details</li>
    </ol>
  </nav>

  <!-- ── Main card ─────────────────────────────────────────────── -->
  <div class="orders-card card">
    <div class="card-body p-0">
      <!-- ── Card header: title + actions only ────────────── -->
      <div class="orders-card__header">
        <h2 class="orders-card__title">Order Details</h2>

        <div class="orders-card__actions">
          <p-button
            *ngIf="orderOption.tabIndex === 0"
            label="Export"
            icon="bx bx-export"
            styleClass="p-button-sm-outline"
            trackClick="click_export_individual_orders"
            (click)="export()"
          ></p-button>

          <p-button
            label="Back"
            styleClass="p-button-sm"
            (click)="back()"
          ></p-button>
        </div>
      </div>

      <!-- ── Tab control ───────────────────────────────────────── -->
      <app-tab-view
        class="orders-tab-view"
        [tabs]="ordersTabs"
        [activeIndex]="orderOption.tabIndex"
        (tabChange)="onChangeTab($event)"
      >
      </app-tab-view>

      <!-- ── Filter bar + tab panel content (kept in one *ngIf per tab so the
           column-chooser's template reference to the tab's own component can
           resolve — refs declared inside a structural directive's embedded
           view are not visible to a sibling *ngIf, even with the same
           condition) ─────────────────────────────────────────────────── -->

      <!-- Individual tab -->
      <ng-container *ngIf="orderOption.tabIndex === 0">
        <div class="orders-filters">
          <div class="row w-100 align-items-center g-0">
            <div class="col-md-4"></div>
            <div class="col-md-8">
              <div class="orders-filters__controls">
                <div class="orders-search-input">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    placeholder="Enter Order ID"
                    [(ngModel)]="searchIndividualOrderId"
                    (ngModelChange)="onSearchIndividualOrderId($event)"
                    (keypress)="onKeyPress($event)"
                    (paste)="onPaste($event)"
                  />
                </div>

                <div class="orders-search-input">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    placeholder="Search by Ref. ID"
                    [(ngModel)]="searchText"
                    (ngModelChange)="onChangeSearchText($event)"
                    (paste)="onSearchTextPaste($event)"
                    (keydown.enter)="onSearchTextEnter()"
                  />
                </div>

                <div class="orders-filter-item rangeDate">
                  <p-datepicker
                    #calendar
                    class="custom-calendar"
                    icon="bx bxs-calendar"
                    [(ngModel)]="rangeDates"
                    (onSelect)="onSelect()"
                    placeholder="Filter Range"
                    [showIcon]="true"
                    iconDisplay="input"
                    [maxDate]="maxDate"
                    selectionMode="range"
                    [readonlyInput]="false"
                    inputId="range"
                    dateFormat="dd.mm.yy"
                    [showButtonBar]="true"
                    (ngModelChange)="onDateRangeChange($event)"
                  >
                  </p-datepicker>
                </div>

                <div class="orders-filter-item">
                  <app-dropdown
                    [options]="branches"
                    [(ngModel)]="selectedBranch"
                    placeholder="Branch"
                    optionLabel="name"
                    (onChange)="onStateChanage($event)"
                    (onClear)="onBranchClear()"
                    [showClear]="true"
                    [filter]="true"
                    filterBy="name"
                    (onFilter)="onBranchFilter($event)"
                    [showClear]="selectedBranch != null && selectedBranch !== ''"
                  ></app-dropdown>
                </div>

                <div class="orders-filter-item">
                  <app-dropdown
                    [options]="orderFilters?.order_type"
                    (onChange)="onServiceTypeChange($event)"
                    (onClear)="onServiceTypeClear()"
                    placeholder="Service Type"
                    optionLabel="name"
                    optionValue="code"
                    [(ngModel)]="selectedService"
                    [showClear]="true"
                    [showClear]="selectedService != null && selectedService !== ''"
                  ></app-dropdown>
                </div>

                <div class="orders-filter-item">
                  <app-multiselect-dropdown
                    [options]="orderFilters?.order_status"
                    (onChange)="onOrderStatusChange($event)"
                    placeholder="Order Status"
                    optionLabel="name"
                    optionValue="code"
                    [(ngModel)]="selectedstatus"
                    [showClear]="true"
                    (onClear)="getAllDetails($event)"
                  ></app-multiselect-dropdown>
                </div>

                <div class="orders-filter-item">
                  <app-column-chooser [table]="individualOrderRef?.dataTable"></app-column-chooser>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="orders-card__body">
          <app-individual-order
            #individualOrderRef
            [orderOption]="orderOption"
            (viewOrderRequested)="viewOrder($event)"
          >
          </app-individual-order>
        </div>
      </ng-container>

      <!-- Bulk tab -->
      <ng-container *ngIf="orderOption.tabIndex === 1">
        <div class="orders-filters">
          <div class="row w-100 align-items-center g-0">
            <div class="col-md-4"></div>
            <div class="col-md-8">
              <div class="orders-filters__controls">
                <div class="orders-search-input" *ngIf="!isViewMoreClicked">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    placeholder="Enter Bulk Order No."
                    [(ngModel)]="searchBulkOrderId"
                    (ngModelChange)="onSearchBulkOrderId($event)"
                    (keypress)="onKeyPress($event)"
                    (paste)="onPaste($event)"
                  />
                </div>

                <ng-container *ngIf="isViewMoreClicked">
                  <div class="orders-search-input">
                    <i class="pi pi-search"></i>
                    <input
                      pInputText
                      type="text"
                      placeholder="Enter Order ID"
                      [(ngModel)]="viewOrderId"
                      (ngModelChange)="viewSearchOrderId($event)"
                      onkeypress="
                        return (
                          (event.charCode >= 48 && event.charCode <= 57) ||
                          event.charCode == 32
                        );
                      "
                    />
                  </div>
                  <div class="orders-search-input">
                    <i class="pi pi-search"></i>
                    <input
                      pInputText
                      type="text"
                      placeholder="Search by Ref. ID"
                      [(ngModel)]="bulkSearchText"
                      (ngModelChange)="onChangeBulkSearchText($event)"
                    />
                  </div>
                </ng-container>

                <div class="orders-filter-item" *ngIf="!isViewMoreClicked">
                  <app-dropdown
                    [options]="orderFilters?.order_type"
                    (onChange)="onServiceTypeChange($event)"
                    (onClear)="onServiceTypeClear()"
                    placeholder="Service Type"
                    optionLabel="name"
                    optionValue="code"
                    [(ngModel)]="selectedService"
                    [showClear]="true"
                    [showClear]="selectedService != null && selectedService !== ''"
                  ></app-dropdown>
                </div>

                <div class="orders-filter-item">
                  <app-multiselect-dropdown
                    [options]="orderFilters?.bulk_status"
                    (onChange)="onBulkOrderStatusChange($event)"
                    placeholder="Order Status"
                    optionLabel="name"
                    optionValue="code"
                    [(ngModel)]="selectedBulkStatus"
                    [showClear]="true"
                    (onClear)="getAllDetails($event)"
                  ></app-multiselect-dropdown>
                </div>

                <div
                  class="orders-filter-item rangeDate"
                  *ngIf="!isViewMoreClicked"
                >
                  <p-datepicker
                    dateFormat="dd/mm/yy"
                    #calendar
                    class="custom-calendar"
                    icon="bx bxs-calendar"
                    [(ngModel)]="rangeDates"
                    (onSelect)="onSelect()"
                    placeholder="Filter Range"
                    [maxDate]="maxDate"
                    [showIcon]="true"
                    iconDisplay="input"
                    selectionMode="range"
                    [readonlyInput]="false"
                    inputId="range"
                    [showButtonBar]="true"
                    (ngModelChange)="onDateRangeChange($event)"
                  >
                  </p-datepicker>
                </div>

                <div class="orders-filter-item" *ngIf="!isViewMoreClicked">
                  <app-column-chooser [table]="bulkOrdersRef?.bulkTable"></app-column-chooser>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="orders-card__body">
          <app-bulk-orders
            #bulkOrdersRef
            [orderOption]="orderOption"
            (bulkOrderChange)="onbulkOrderOptionChange($event)"
          >
          </app-bulk-orders>
        </div>
      </ng-container>

      <!-- Automated Bulk Upload tab -->
      <ng-container *ngIf="orderOption.tabIndex === 2 && isShowAutoBulkOption">
        <div class="orders-filters">
          <div class="row w-100 align-items-center g-0">
            <div class="col-md-4"></div>
            <div class="col-md-8">
              <div class="orders-filters__controls">
                <div class="orders-filter-item">
                  <app-multiselect-dropdown
                    [options]="bulk_estamp_order_status"
                    (onChange)="onBulkEstampOrderStatusChange($event)"
                    placeholder="Order Status"
                    optionLabel="name"
                    optionValue="code"
                    [showClear]="true"
                    (onClear)="getAllDetails($event)"
                  ></app-multiselect-dropdown>
                </div>

                <div class="orders-filter-item">
                  <app-column-chooser [table]="automatedBulkOrderRef?.groupTable"></app-column-chooser>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="orders-card__body">
          <app-automated-bulk-order
            #automatedBulkOrderRef
            [orderOption]="orderOption"
            (automatedBulkOrderChange)="
              onAutomatedBulkOrderOptionChange($event)
            "
          >
          </app-automated-bulk-order>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>

<ng-template #viewOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Order</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeView()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <app-view-order [viewOrderId]="viewOrderId"></app-view-order>
  </div>
</ng-template>
